export function getEnvironmentVariable(key: string, fallback: string): string {
  const meta = document.querySelector(`meta[name="env-${key}"]`);
  const value = meta ? meta.getAttribute('content') : null;
  if (!value || value.startsWith('${')) {
    return fallback;
  }
  return value;
}
